module.exports = "pegasus/assets/restaurant-alcohol-bar-drinks.png";